import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import Table from '../components/Table2.vue'
import Detail from '../components/Detail.vue'
import Detail2 from '../components/Detail2.vue'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Table
  },
  {
    path: '/detail',
    name: 'Detail',
    component: Detail
  }
  // {
  //   path: '/detail2',
  //   name: 'Detail2',
  //   component: Detail2,
  //   props: route => ({query: route.query.event})
  // }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
